(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7652],{

/***/ 20582:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketplace/_internal/for-sale/[address_id]",
      function () {
        return __webpack_require__(54578);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 54578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _address_id_; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.11.1_@types+react@18.3.28_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(78049);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(44142);
// EXTERNAL MODULE: ./src/components/marketplace/helpers/index.ts + 5 modules
var helpers = __webpack_require__(89569);
// EXTERNAL MODULE: ./src/components/marketplace/helpers/useTrackProperty.ts
var useTrackProperty = __webpack_require__(81191);
// EXTERNAL MODULE: ./src/components/marketplace/property/index.ts + 7 modules
var marketplace_property = __webpack_require__(70571);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/Box/Col.js
var Col = __webpack_require__(25136);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/header/Header.tsx + 3 modules
var Header = __webpack_require__(88216);
// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(30465);
;// CONCATENATED MODULE: ./src/components/properties/components/CoverImages.tsx
// Homes Placeholder SVG
var FALLBACK_URL = "https://images.opendoor.com/source/s3/imgdrop-production/ce1501221958405990f1d0d7fe935c51.svg?preset=square-2048";

;// CONCATENATED MODULE: ./src/components/properties/helpers/property.ts



function getHumanReadableAddress(street, unitType, unitNumber, city, state, postalCode) {
    var formattedStreet = (0,helpers/* formatStreetAddress */.Dm)(street, unitType, unitNumber);
    if (!formattedStreet || !city || !state || !postalCode) {
        return "";
    }
    return "".concat(formattedStreet, ", ").concat(city, ", ").concat(state, " ").concat(postalCode);
}
var getReadableListingStatus = function(listingState) {
    if (!listingState) {
        return "Unknown";
    }
    if (listingState === "SELL_REQUEST_TEMP_OFF_MARKET") {
        return "Off Market";
    }
    return listingState.substring("SELL_REQUEST_".length).split("_").map(function(input) {
        return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
    }).join(" ");
};
var getSeoFields = function(addressId, displaySlug, status, street, unitType, unitNumber, city, state, postalCode, sqFtLot, bedrooms, bathrooms, yearBuilt, coverImageProp) {
    var ref;
    var readableAddress = getHumanReadableAddress(street, unitType, unitNumber, city, state, postalCode);
    var title = "Home for sale - ".concat(readableAddress, " | Opendoor");
    var canonicalUrl = displaySlug ? "".concat(globals/* COSMOS_URL */.EQ, "/properties/").concat(displaySlug, "/aid_").concat(addressId) : "".concat(globals/* COSMOS_URL */.EQ, "/properties/").concat(street ? "".concat((ref = street === null || street === void 0 ? void 0 : street.toLowerCase()) === null || ref === void 0 ? void 0 : ref.replaceAll(" ", "-"), "-") : "").concat(unitNumber ? "".concat(unitNumber, "-") : "").concat(city ? "".concat(city === null || city === void 0 ? void 0 : city.toLowerCase(), "-") : "", "-").concat(state === null || state === void 0 ? void 0 : state.toLowerCase()).concat(postalCode, "/aid_").concat(addressId);
    var forSale = getReadableListingStatus(status) === "Active";
    var metaDescription = "".concat(readableAddress, " is currently ").concat(forSale ? "for sale" : "not for sale", ". The ").concat(sqFtLot ? "".concat(sqFtLot, " sq ft.") : "", " home ").concat(yearBuilt ? "was built in ".concat(yearBuilt) : "", " ").concat(bedrooms ? "and has ".concat(bedrooms, " bedrooms") : "", " ").concat(bathrooms ? "and has ".concat(bathrooms, " bathrooms") : "", ". Learn more about the home on Opendoor.");
    var coverImage = FALLBACK_URL;
    if (coverImageProp) {
        // Use a larger preset so link previews (iMessage/SMS, Facebook, Twitter, WhatsApp)
        // render a high-quality hero image rather than a tiny thumbnail.
        coverImage = "".concat(coverImageProp, "?").concat(new URLSearchParams({
            preset: "3:2-lg",
            service: "cosmos"
        }).toString());
    }
    return {
        readableAddress: readableAddress,
        canonicalUrl: canonicalUrl,
        metaDescription: metaDescription,
        title: title,
        coverImage: coverImage
    };
};

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(59106);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.29.0_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.99.0/node_modules/next/head.js
var head = __webpack_require__(20315);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/components/properties/shared/SeoHead.tsx




var getBaseTags = function(props) {
    return [
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
            children: props.title
        }, "title"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            name: "description",
            content: props.metaDescription
        }, "description"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            name: "author",
            content: props.author
        }, "author"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
            rel: "canonical",
            href: props.canonicalUrl
        }, "canonical"), 
    ];
};
var getOgTags = function(props) {
    if (!props) {
        return null;
    }
    var url = props.url, title = props.title, description = props.description, image = props.image, imageAlt = props.imageAlt, siteName = props.siteName, type = props.type;
    var tags = [
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            property: "og:title",
            content: title
        }, "og:title"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            property: "og:url",
            content: url
        }, "og:url"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            property: "og:type",
            content: type
        }, "og:type"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            property: "og:description",
            content: description
        }, "og:description"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            property: "og:image",
            content: image
        }, "og:image"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            property: "og:image:secure_url",
            content: image
        }, "og:image:secure_url"),
        imageAlt ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            property: "og:image:alt",
            content: imageAlt
        }, "og:image:alt") : null,
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            property: "og:site_name",
            content: siteName
        }, "og:site_name"), 
    ];
    return tags;
};
// Twitter card tags are read by iMessage/SMS previews, Twitter/X, Slack, and
// other messaging clients. Without them they fall back to the site-wide
// defaults set in `_app.tsx`, which show the Opendoor logo instead of the
// property's hero photo.
var getTwitterTags = function(props) {
    if (!props) {
        return null;
    }
    var url = props.url, title = props.title, description = props.description, image = props.image, imageAlt = props.imageAlt;
    return [
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            name: "twitter:card",
            content: "summary_large_image"
        }, "twitter:card"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            name: "twitter:url",
            content: url
        }, "twitter:url"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            name: "twitter:title",
            content: title
        }, "twitter:title"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            name: "twitter:description",
            content: description
        }, "twitter:description"),
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            name: "twitter:image",
            content: image
        }, "twitter:image"),
        imageAlt ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
            name: "twitter:image:alt",
            content: imageAlt
        }, "twitter:image:alt") : null, 
    ];
};
var getPropertySchemaData = function(props) {
    var address = props.address, floorSize = props.floorSize, listPrice = props.listPrice, url = props.url, lat = props.lat, lon = props.lon, hasSelfTour = props.hasSelfTour, addressToken = props.addressToken, remainingProps = (0,_object_without_properties/* default */.Z)(props, [
        "address",
        "floorSize",
        "listPrice",
        "url",
        "lat",
        "lon",
        "hasSelfTour",
        "addressToken"
    ]);
    var schemaData = (0,_object_spread/* default */.Z)({
        "@context": "https://schema.org/",
        "@type": [
            "SingleFamilyResidence",
            "Product"
        ]
    }, address && {
        address: (0,_object_spread/* default */.Z)({
            "@type": "PostalAddress"
        }, address)
    }, lat && lon && {
        geo: {
            "@type": "GeoCoordinates",
            latitude: lat,
            longitude: lon
        }
    }, floorSize && {
        floorSize: (0,_object_spread/* default */.Z)({
            "@type": "QuantitativeValue"
        }, floorSize)
    }, hasSelfTour && addressToken && {
        tourBookingPage: "https://consumer.opendoor.com/dashboard/buy/tour?id=".concat(addressToken)
    }, listPrice && url && {
        offers: {
            "@type": "Offer",
            priceCurrency: "USD",
            price: listPrice,
            url: url,
            availability: "http://schema.org/InStock"
        }
    }, remainingProps);
    return schemaData;
};
var SeoHead = function(props) {
    var base = props.base, og = props.og, schema = props.schema;
    // ensure that you don't nest tags inside of fragments
    // if you do that, then the next head component
    // will have issues with overrides
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
        children: [
            getBaseTags(base),
            getOgTags(og),
            getTwitterTags(og),
            schema && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(getPropertySchemaData(schema))
                }
            })
        ]
    });
};
/* harmony default export */ var shared_SeoHead = (SeoHead);

// EXTERNAL MODULE: ./src/components/shared/GlobalStyles.tsx
var GlobalStyles = __webpack_require__(80985);
;// CONCATENATED MODULE: ./src/components/properties/shared/MarketplaceLayout.tsx











var mainNavLinks = [
    {
        name: "How it works",
        href: "/how-it-works-sell"
    },
    {
        name: "Browse homes",
        href: "/homes"
    }, 
];
var menuPanelNavLinks = [
    {
        name: "Work with a builder",
        href: "/builder"
    },
    {
        name: "Opendoor for Agents",
        href: "/agents"
    }, 
];
var MarketplaceLayout = function(param) {
    var children = param.children, property = param.property, navHeader = param.navHeader;
    var ref;
    var ref1;
    var resolvedMainNavLinks = (ref1 = navHeader === null || navHeader === void 0 ? void 0 : navHeader.mainNavLinks) !== null && ref1 !== void 0 ? ref1 : mainNavLinks;
    var ref2;
    var resolvedMenuPanelNavLinks = (ref2 = navHeader === null || navHeader === void 0 ? void 0 : navHeader.menuPanelNavLinks) !== null && ref2 !== void 0 ? ref2 : menuPanelNavLinks;
    var megaNavData = navHeader === null || navHeader === void 0 ? void 0 : navHeader.megaNavData;
    var ref3 = getSeoFields(property === null || property === void 0 ? void 0 : property.addressToken, property === null || property === void 0 ? void 0 : property.slug, undefined, property === null || property === void 0 ? void 0 : property.street, property === null || property === void 0 ? void 0 : property.unitType, property === null || property === void 0 ? void 0 : property.unitNumber, property === null || property === void 0 ? void 0 : property.city, property === null || property === void 0 ? void 0 : property.state, property === null || property === void 0 ? void 0 : property.zip, property === null || property === void 0 ? void 0 : property.sqFtLot, property === null || property === void 0 ? void 0 : property.bedrooms, property === null || property === void 0 ? void 0 : property.bathrooms, property === null || property === void 0 ? void 0 : property.yearBuilt, property === null || property === void 0 ? void 0 : (ref = property.photos) === null || ref === void 0 ? void 0 : ref[0]), coverImage = ref3.coverImage, readableAddress = ref3.readableAddress, title = ref3.title, canonicalUrl = ref3.canonicalUrl;
    var metaDescription = "View photos, details, and schedule a self-tour of this ".concat(property === null || property === void 0 ? void 0 : property.bedrooms, " bedroom, ").concat(property === null || property === void 0 ? void 0 : property.bathrooms, " bathroom, ").concat(property === null || property === void 0 ? void 0 : property.sqFtTotalLiving, " sqft home located at ").concat(readableAddress, ".");
    var seoHead = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_SeoHead, {
        base: {
            title: title,
            author: "Opendoor, Inc.",
            metaDescription: metaDescription,
            canonicalUrl: canonicalUrl
        },
        og: {
            url: canonicalUrl,
            title: title,
            description: metaDescription,
            siteName: "Opendoor",
            image: coverImage,
            imageAlt: readableAddress ? "Photo of home for sale at ".concat(readableAddress) : "Home for sale on Opendoor",
            type: "website"
        },
        schema: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            name: readableAddress,
            description: metaDescription,
            url: canonicalUrl,
            address: (0,_object_spread/* default */.Z)({}, (property === null || property === void 0 ? void 0 : property.street) && {
                streetAddress: (0,helpers/* formatStreetAddress */.Dm)(property.street, property.unitType, property.unitNumber) || undefined
            }, (property === null || property === void 0 ? void 0 : property.city) && {
                addressLocality: property.city
            }, (property === null || property === void 0 ? void 0 : property.state) && {
                addressRegion: property.state
            }, (property === null || property === void 0 ? void 0 : property.zip) && {
                postalCode: property.zip
            })
        }, (property === null || property === void 0 ? void 0 : property.sqFtLot) && {
            floorSize: {
                value: property.sqFtLot.toString()
            }
        }, (property === null || property === void 0 ? void 0 : property.yearBuilt) && {
            yearBuilt: property.yearBuilt.toString()
        }, (property === null || property === void 0 ? void 0 : property.bedrooms) && {
            numberOfBedrooms: property.bedrooms.toString()
        }, (property === null || property === void 0 ? void 0 : property.bathrooms) && {
            numberOfBathroomsTotal: property.bathrooms.toString()
        }, (property === null || property === void 0 ? void 0 : property.listPrice) && !(0,helpers/* isBuyDirectEligible */.pX)(property) && {
            listPrice: property.listPrice
        }, (property === null || property === void 0 ? void 0 : property.buyDirectPrice) && (0,helpers/* isBuyDirectEligible */.pX)(property) && {
            listPrice: property.buyDirectPrice
        }), {
            image: coverImage,
            lat: property === null || property === void 0 ? void 0 : property.latitude,
            lon: property === null || property === void 0 ? void 0 : property.longitude
        }), (property === null || property === void 0 ? void 0 : property.canSelfTour) && {
            hasSelfTour: property === null || property === void 0 ? void 0 : property.canSelfTour
        }), {
            addressToken: property === null || property === void 0 ? void 0 : property.addressToken
        })
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preload",
                        href: "/fonts/graphik-regular/Graphik-Regular.woff2",
                        as: "font",
                        type: "font/woff2",
                        crossOrigin: "anonymous"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preload",
                        href: "/fonts/graphik-semibold/Graphik-Semibold.woff2",
                        as: "font",
                        type: "font/woff2",
                        crossOrigin: "anonymous"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preconnect",
                        href: "https://images.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "dns-prefetch",
                        href: "https://images.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preconnect",
                        href: "https://cdn-cosmos.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "dns-prefetch",
                        href: "https://cdn-cosmos.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        httpEquiv: "X-UA-Compatible",
                        content: "IE=edge,chrome=1"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        name: "viewport",
                        content: "width=device-width,initial-scale=1"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        httpEquiv: "Accept-CH",
                        content: "DPR, Width, Viewport-Width"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "apple-touch-icon",
                        sizes: "144x144",
                        href: "https://www.opendoor.com/apple-touch-icon-144.png"
                    })
                ]
            }),
            seoHead,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlobalStyles/* default */.Z, {
                fontWeights: [
                    "regular",
                    "semibold",
                    "bold",
                    "medium"
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                backgroundColor: "$backgroundPrimary",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header/* default */.Z, {
                        slug: "homes",
                        mainNavLinks: resolvedMainNavLinks,
                        menuPanelNavLinks: resolvedMenuPanelNavLinks,
                        megaNavData: megaNavData,
                        ctaTitle: navHeader === null || navHeader === void 0 ? void 0 : navHeader.ctaTitle,
                        ctaLink: navHeader === null || navHeader === void 0 ? void 0 : navHeader.ctaLink
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        tag: "main",
                        tabIndex: -1,
                        "$platform-web": {
                            overflowX: "hidden"
                        },
                        backgroundColor: "$backgroundPrimary",
                        children: children
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var shared_MarketplaceLayout = (MarketplaceLayout);

// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.29.0_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.99.0/node_modules/next/dynamic.js
var dynamic = __webpack_require__(57576);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/helpers/observability.ts
var observability = __webpack_require__(70831);
;// CONCATENATED MODULE: ./src/pages/marketplace/_internal/for-sale/[address_id].tsx











var Lightbox = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 66288)).then(function(mod) {
        return mod.Lightbox;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(66288)
            ];
        }
    },
    ssr: false
});
var ShareModal = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 96956)).then(function(mod) {
        return mod.ShareModal;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96956)
            ];
        }
    },
    ssr: false
});
var PropertySection = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 58525)).then(function(mod) {
        return mod.PropertySection;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(58525)
            ];
        }
    },
    ssr: false
});
var Page = function(props) {
    var property = props === null || props === void 0 ? void 0 : props.property;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(useTrackProperty/* PropertyAnalytics.Provider */.K.Provider, {
        value: {
            property: property
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PageInner, (0,_object_spread/* default */.Z)({}, props))
    });
};
var PageInner = function(param) {
    var property = param.property, navHeader = param.navHeader;
    var trackProperty = (0,useTrackProperty/* useTrackProperty */.a)().trackProperty;
    var trackJourneyEvent = (0,observability/* useObservability */.C3)().trackJourneyEvent;
    var ref = (0,react.useState)(false), isLightboxOpen = ref[0], setIsLightboxOpen = ref[1];
    var ref1 = (0,react.useState)(false), isShareModalOpen = ref1[0], setIsShareModalOpen = ref1[1];
    var ref2 = (0,react.useState)(0), selectedPhotoIndex = ref2[0], setSelectedPhotoIndex = ref2[1];
    var toggleLightbox = (0,react.useCallback)(function() {
        return setIsLightboxOpen(function(prev) {
            return !prev;
        });
    }, []);
    // bricks-next `Lightbox` registers a document-level keydown listener that
    // fires `handleClose()` on Escape regardless of `isOpen`, so `handleClose`
    // must be close-only rather than a toggle.
    var closeLightbox = (0,react.useCallback)(function() {
        return setIsLightboxOpen(false);
    }, []);
    var handleSetSelectedPhotoIndex = (0,react.useCallback)(function(idx) {
        return setSelectedPhotoIndex(idx);
    }, []);
    var ref3 = (0,helpers/* usePropertyReactions */.O8)(property.addressToken, "REACTION_SOURCE_WEB_PDP"), isLiked = ref3.isLiked, onClickReaction = ref3.onClickReaction;
    /**
   * The initial page load for customers will include the cached similar properties.
   * This hook executes client-side to retrieve the latest similar listings.
   */ var marketplaceProperty = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, property), {
        isLiked: isLiked,
        onClickReaction: onClickReaction
    });
    var similarProperties = (0,helpers/* useSimilarProperties */.n6)(property.addressToken).similarProperties;
    if (similarProperties === null || similarProperties === void 0 ? void 0 : similarProperties.results) {
        marketplaceProperty.similarProperties = similarProperties;
    }
    var sellerDisclosures = (0,helpers/* useSellerDisclosures */.FZ)(property.addressToken).sellerDisclosures;
    if (sellerDisclosures) {
        marketplaceProperty.sellerDisclosuresDownloadUrl = sellerDisclosures;
    }
    var formattedAddress = (0,react.useMemo)(function() {
        return (0,helpers/* formatStreetAddress */.Dm)(property.street, property.unitType, property.unitNumber);
    }, [
        property.street,
        property.unitType,
        property.unitNumber
    ]);
    var carouselPhotos = (0,react.useMemo)(function() {
        return (0,helpers/* buildGalleryPhotos */.hk)(marketplaceProperty);
    }, [
        marketplaceProperty.photos,
        marketplaceProperty.floorPlanPhotos
    ]);
    (0,react.useEffect)(function() {
        trackProperty("property-view", "marketplace-pdp");
        trackJourneyEvent("marketplaceProperty", "detailPageView", {
            addressUuid: property.addressToken
        });
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_MarketplaceLayout, {
        property: marketplaceProperty,
        navHeader: navHeader,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            $smallerThanMD: {
                flexDirection: "column",
                overflowY: "scroll"
            },
            $largerThanSM: {
                flexDirection: "row",
                height: "calc(100vh - 72px)"
            },
            overflow: "hidden",
            width: "100vw",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(marketplace_property/* GalleryPhotos */.Ub, {
                    handleSetSelectedPhotoIndex: handleSetSelectedPhotoIndex,
                    property: marketplaceProperty,
                    toggleLightbox: toggleLightbox
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(marketplace_property/* PhotoCarousel */.cS, {
                    photos: carouselPhotos,
                    price: (marketplaceProperty === null || marketplaceProperty === void 0 ? void 0 : marketplaceProperty.displayBadge) === "ON_THE_MARKET" && (0,helpers/* isBuyDirectEligible */.pX)(marketplaceProperty) ? marketplaceProperty.buyDirectPrice : marketplaceProperty.listPrice,
                    address: formattedAddress,
                    toggleLightbox: toggleLightbox,
                    setSelectedPhotoIndex: handleSetSelectedPhotoIndex,
                    latitude: marketplaceProperty.latitude,
                    longitude: marketplaceProperty.longitude,
                    openShareModal: function() {
                        return setIsShareModalOpen(true);
                    }
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Lightbox, {
                    handleClose: closeLightbox,
                    isOpen: isLightboxOpen,
                    property: marketplaceProperty,
                    selectedPhotoIndex: selectedPhotoIndex
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropertySection, {
                    property: marketplaceProperty
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShareModal, {
                    property: marketplaceProperty,
                    isOpen: isShareModalOpen,
                    onClose: function() {
                        return setIsShareModalOpen(false);
                    }
                })
            ]
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var _address_id_ = (Page);


/***/ }),

/***/ 78578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Checkmark_default; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59106);
/* harmony import */ var react_native_svg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8270);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64978);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31549);






var SvgCheckmark = function(_param) {
    var _size = _param.size, size = _size === void 0 ? 24 : _size, _color = _param.color, color = _color === void 0 ? "$contentPrimary" : _color, inProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "size",
        "color"
    ]);
    var outProps = {};
    if (size && (outProps.width = size, outProps.height = size), color) {
        var colorToken = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.getToken)(color, "color");
        outProps.color = colorToken;
    }
    var props = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, inProps, outProps);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Svg */ .ny, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none"
    }, props), {
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Path */ .y$, {
            fill: "currentColor",
            d: "m9.218 15.319 9.967-9.966Q19.537 5 20.022 5q.486 0 .838.353.354.352.353.838 0 .484-.353.838L10.042 17.847q-.354.353-.824.353t-.823-.353L3.34 12.791A1.1 1.1 0 0 1 3 11.953a1.2 1.2 0 0 1 .367-.838q.353-.353.838-.353t.838.353z"
        })
    }));
};
var Checkmark_default = SvgCheckmark;



/***/ }),

/***/ 10270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ TextButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59106);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64069);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64978);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _generated_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(75017);
/* harmony import */ var _generated_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6985);
/* harmony import */ var _helpers_tokens__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50622);
/* harmony import */ var _shared_anchorOrButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63194);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34816);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31549);











var textButtonTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__/* .tokens.textButton */ .T.textButton, buttonTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__/* .tokens.button */ .T.button, sharedFrameConfig = {
    name: "TextButton",
    display: "flex",
    flexDirection: "row",
    gap: textButtonTokens.padding.labelIconGap.default,
    userSelect: "none",
    cursor: "pointer",
    // Browser resets
    padding: 0,
    borderWidth: 0,
    backgroundColor: "$transparent",
    focusVisibleStyle: {
        outlineStyle: "solid",
        outlineWidth: textButtonTokens.borderWidth.state.default,
        outlineOffset: textButtonTokens.padding.state.focused.default,
        borderRadius: textButtonTokens.cornerRadius.state.focused
    },
    pressStyle: {
        scale: (0,_helpers_tokens__WEBPACK_IMPORTED_MODULE_3__/* .getStateTokenValue */ .GJ)(buttonTokens.state.pressedScale)
    },
    variants: {
        variant: function(variant) {
            return {
                focusVisibleStyle: {
                    outlineColor: variant === "secondaryInverse" ? textButtonTokens.color.border.state.inverse : textButtonTokens.color.border.state.default
                }
            };
        },
        disabled: {
            true: {
                pointerEvents: "none"
            }
        }
    }
}, AnchorFrame = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, sharedFrameConfig), {
    tag: "a",
    accessibilityRole: "link",
    textDecorationLine: "none",
    display: "flex",
    position: "relative"
})), ButtonFrame = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.View, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, sharedFrameConfig), {
    tag: "button",
    accessibilityRole: "button"
})), AnchorOrButtonFrame = (0,_shared_anchorOrButton__WEBPACK_IMPORTED_MODULE_7__/* .createAnchorOrButtonFrame */ .r)({
    AnchorFrame: AnchorFrame,
    ButtonFrame: ButtonFrame
}), TextButton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(_param, ref) {
    var variant = _param.variant, disabled = _param.disabled, label = _param.label, onHoverIn = _param.onHoverIn, onHoverOut = _param.onHoverOut, chevronIcon = _param.chevronIcon, fontWeight = _param.fontWeight, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "variant",
        "disabled",
        "label",
        "onHoverIn",
        "onHoverOut",
        "chevronIcon",
        "fontWeight"
    ]);
    var _$ref = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.useProps)(rest), _size = _$ref.size, size = _size === void 0 ? "medium" : _size, _$ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), isHovering = _$ref1[0], setIsHovering = _$ref1[1], hoverNone = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.useMedia)().hoverNone, handleHoverIn = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        !hoverNone && setIsHovering(!0), onHoverIn === null || onHoverIn === void 0 ? void 0 : onHoverIn(e);
    }, [
        hoverNone,
        onHoverIn
    ]), handleHoverOut = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        !hoverNone && setIsHovering(!1), onHoverOut === null || onHoverOut === void 0 ? void 0 : onHoverOut(e);
    }, [
        hoverNone,
        onHoverOut
    ]), color = disabled ? textButtonTokens.color.content.state.inactive[variant] : isHovering ? textButtonTokens.color.content.state.hover[variant] : textButtonTokens.color.content[variant];
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(AnchorOrButtonFrame, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        variant: variant,
        disabled: disabled,
        "aria-disabled": disabled,
        focusable: !disabled,
        onHoverIn: handleHoverIn,
        onHoverOut: handleHoverOut,
        ref: ref
    }, rest), {
        children: [
            chevronIcon === "left" && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_generated_icons__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                size: size === "large" ? 24 : 20,
                color: color
            }),
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
                tag: "span",
                typography: textButtonTokens.typography[size],
                textDecorationLine: variant === "primary" || chevronIcon ? "none" : "underline",
                color: color,
                fontWeight: fontWeight ? textButtonTokens.fontWeight[fontWeight] : void 0,
                children: label
            }),
            chevronIcon === "right" && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_generated_icons__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                size: size === "large" ? 24 : 20,
                color: color
            })
        ]
    }));
});



/***/ }),

/***/ 64537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ components_Dialog_Dialog; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+core@1.110.0_react@18.3.1/node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(64978);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(59106);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@opendoor+tokens-studio@16.2.0/node_modules/@opendoor/tokens-studio/dist/bricks-next/tokens/Components.js
var Components = __webpack_require__(64069);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(44142);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/Button/Button.js
var Button = __webpack_require__(26291);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/inputs/checkboxRadio/SimpleCheckbox.js
var SimpleCheckbox = __webpack_require__(11509);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(31549);
;// CONCATENATED MODULE: ../bricks-next/dist/jsx/components/Dialog/Actions.js









var dialogTokens = Components/* tokens.dialog */.T.dialog, Container = function(_param) /* @__PURE__ */ {
    var children = _param.children, $largerThanSM = _param.$largerThanSM, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "$largerThanSM"
    ]);
    return (0,jsx_runtime.jsx)(Box/* Box */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        marginTop: -1 * (0,cjs.getTokenValue)(dialogTokens.margin.mobile.bottom),
        $largerThanSM: (0,_object_spread/* default */.Z)({
            marginTop: -1 * (0,cjs.getTokenValue)(dialogTokens.margin.desktop.bottom)
        }, $largerThanSM)
    }, props), {
        children: children
    }));
}, ButtonContainer = function(param) {
    var children = param.children, buttonPosition = param.buttonPosition;
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        paddingTop: dialogTokens.padding.mobile.betweenElements,
        paddingBottom: dialogTokens.margin.mobile.bottom,
        paddingHorizontal: dialogTokens.margin.mobile.leftRight,
        $largerThanSM: {
            paddingBottom: dialogTokens.margin.desktop.bottom,
            paddingHorizontal: dialogTokens.margin.desktop.leftRight,
            flexDirection: buttonPosition === "stacked" ? "column" : "row"
        },
        gap: dialogTokens.padding.actions.default,
        children: children
    });
}, Actions = function(_param) /* @__PURE__ */ {
    var buttonPosition = _param.buttonPosition, buttonOneProps = _param.buttonOneProps, buttonTwoProps = _param.buttonTwoProps, checkboxProps = _param.checkboxProps, props = (0,_object_without_properties/* default */.Z)(_param, [
        "buttonPosition",
        "buttonOneProps",
        "buttonTwoProps",
        "checkboxProps"
    ]);
    return (0,jsx_runtime.jsxs)(Container, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            checkboxProps && /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                paddingTop: dialogTokens.margin.mobile.top,
                paddingHorizontal: dialogTokens.margin.mobile.leftRight,
                $largerThanSM: {
                    paddingTop: 0,
                    paddingHorizontal: dialogTokens.margin.desktop.leftRight
                },
                children: /* @__PURE__ */ (0,jsx_runtime.jsx)(SimpleCheckbox/* SimpleCheckbox */.A, (0,_object_spread/* default */.Z)({}, checkboxProps))
            }),
            /* @__PURE__ */ (0,jsx_runtime.jsxs)(ButtonContainer, {
                buttonPosition: buttonPosition,
                children: [
                    buttonOneProps && /* @__PURE__ */ (0,jsx_runtime.jsx)(Button/* Button */.z, (0,_object_spread/* default */.Z)({
                        variant: "primary",
                        size: "small",
                        $largerThanSM: {
                            size: "medium",
                            flexGrow: 1
                        }
                    }, buttonOneProps)),
                    buttonTwoProps && /* @__PURE__ */ (0,jsx_runtime.jsx)(Button/* Button */.z, (0,_object_spread/* default */.Z)({
                        variant: "secondary",
                        size: "small",
                        $largerThanSM: {
                            size: "medium",
                            flexGrow: 1
                        }
                    }, buttonTwoProps))
                ]
            })
        ]
    }));
};


// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+dialog@1.110.0_@types+react-native@0.73.0_@babel+core@7.29.0_@babel+preset-env_960717958a5d620dbca22ece05417c8e/node_modules/@tamagui/dialog/dist/esm/Dialog.mjs + 45 modules
var Dialog = __webpack_require__(42558);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-native-web@0.19.12_encoding@0.1.13_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-native-web/dist/exports/ScrollView/index.js + 1 modules
var ScrollView = __webpack_require__(26330);
;// CONCATENATED MODULE: ../bricks-next/dist/jsx/components/shared/VisuallyHidden.js





var VisuallyHidden = function(_param) {
    var children = _param.children, visible = _param.visible, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "visible"
    ]);
    return visible ? children : /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        position: "absolute",
        width: 1,
        height: 1,
        margin: -1,
        zIndex: -1e4,
        overflow: "hidden",
        opacity: 1e-8,
        pointerEvents: "none"
    }, props), {
        children: children
    }));
};


;// CONCATENATED MODULE: ../bricks-next/dist/jsx/components/Dialog/Content.js









var Content_dialogTokens = Components/* tokens.dialog */.T.dialog, StyledTitle = (0,cjs.styled)(Dialog/* Dialog.Title */.Vq.Title, {
    name: "DialogTitle",
    fontFamily: "$body",
    color: Content_dialogTokens.color.content.default,
    variants: {
        typography: {
            "...fontSize": function(fontSize) {
                return {
                    fontSize: fontSize,
                    fontWeight: fontSize,
                    letterSpacing: fontSize,
                    lineHeight: fontSize
                };
            }
        }
    }
}), StyledDescription = (0,cjs.styled)(Dialog/* Dialog.Description */.Vq.Description, {
    name: "DialogDescription",
    fontFamily: "$body",
    color: Content_dialogTokens.color.content.default,
    variants: {
        typography: {
            "...fontSize": function(fontSize) {
                return {
                    fontSize: fontSize,
                    fontWeight: fontSize,
                    letterSpacing: fontSize,
                    lineHeight: fontSize
                };
            }
        }
    }
}), Title = function(propsIn) {
    var props = (0,cjs.useProps)(propsIn);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(StyledTitle, (0,_object_spread/* default */.Z)({}, props));
}, Description = function(propsIn) {
    var props = (0,cjs.useProps)(propsIn);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(StyledDescription, (0,_object_spread/* default */.Z)({}, props));
}, ScrollViewWrapper = function(param) {
    var children = param.children;
    var smallerThanMD = (0,cjs.useMedia)().smallerThanMD;
    return smallerThanMD ? /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Sheet.ScrollView */.Vq.Sheet.ScrollView, {
        flex: 0,
        children: children
    }) : /* @__PURE__ */ (0,jsx_runtime.jsx)(ScrollView/* default */.Z, {
        children: children
    });
}, Content = function(param) {
    var title = param.title, titleProps = param.titleProps, hideTitle = param.hideTitle, description = param.description, descriptionProps = param.descriptionProps, hideDescription = param.hideDescription, children = param.children;
    /* @__PURE__ */ return (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        flexGrow: 1,
        flexShrink: 1,
        paddingTop: Content_dialogTokens.margin.mobile.top,
        paddingBottom: Content_dialogTokens.margin.mobile.bottom,
        $largerThanSM: {
            paddingTop: Content_dialogTokens.margin.desktop.top,
            paddingBottom: Content_dialogTokens.margin.desktop.bottom
        },
        children: [
            /* @__PURE__ */ (0,jsx_runtime.jsx)(VisuallyHidden, {
                visible: !hideTitle,
                children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                    paddingHorizontal: Content_dialogTokens.margin.mobile.leftRight,
                    paddingBottom: Content_dialogTokens.padding.titleAndDescription.mobile,
                    $largerThanSM: {
                        paddingHorizontal: Content_dialogTokens.margin.desktop.leftRight,
                        paddingBottom: Content_dialogTokens.padding.titleAndDescription.desktop
                    },
                    children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Title, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        typography: Content_dialogTokens.typography.title.small
                    }, titleProps), {
                        $largerThanSM: (0,_object_spread/* default */.Z)({
                            typography: Content_dialogTokens.typography.title.medium,
                            marginRight: Content_dialogTokens.margin.desktop.titleRight
                        }, titleProps === null || titleProps === void 0 ? void 0 : titleProps.$largerThanSM),
                        children: title
                    }))
                })
            }),
            /* @__PURE__ */ (0,jsx_runtime.jsx)(ScrollViewWrapper, {
                children: /* @__PURE__ */ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                    paddingHorizontal: Content_dialogTokens.margin.mobile.leftRight,
                    $largerThanSM: {
                        paddingHorizontal: Content_dialogTokens.margin.desktop.leftRight
                    },
                    children: [
                        /* @__PURE__ */ (0,jsx_runtime.jsx)(VisuallyHidden, {
                            visible: !hideDescription,
                            children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Description, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                typography: Content_dialogTokens.typography.description.small
                            }, descriptionProps), {
                                $largerThanSM: (0,_object_spread/* default */.Z)({
                                    typography: Content_dialogTokens.typography.description.medium
                                }, descriptionProps === null || descriptionProps === void 0 ? void 0 : descriptionProps.$largerThanSM),
                                children: description
                            }))
                        }),
                        /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                            children: children
                        })
                    ]
                })
            })
        ]
    });
};


// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-native-web@0.19.12_encoding@0.1.13_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-native-web/dist/exports/useWindowDimensions/index.js
var useWindowDimensions = __webpack_require__(31799);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/helpers/tokens.js
var tokens = __webpack_require__(50622);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/Button/IconButton.js
var IconButton = __webpack_require__(70878);
// EXTERNAL MODULE: ../../node_modules/.pnpm/expo-blur@13.0.2_expo@55.0.24/node_modules/expo-blur/build/BlurView.web.js + 1 modules
var BlurView_web = __webpack_require__(29433);
;// CONCATENATED MODULE: ../bricks-next/dist/jsx/components/Dialog/BackgroundBlur.js







var BackgroundBlur = function(_param) {
    var blurRadius = _param.blurRadius, props = (0,_object_without_properties/* default */.Z)(_param, [
        "blurRadius"
    ]);
    var intensity = (0,react.useMemo)(function() {
        return (typeof blurRadius == "number" ? blurRadius : (0,cjs.getTokenValue)(blurRadius, "backgroundBlur")) * 5;
    }, [
        blurRadius
    ]);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(BlurView_web/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        intensity: intensity
    }));
};


;// CONCATENATED MODULE: ../bricks-next/dist/jsx/components/Dialog/Dialog.js











var Dialog_dialogTokens = Components/* tokens.dialog */.T.dialog, Dialog_Dialog = function(param) {
    var isOpen = param.isOpen, _animation = param.animation, animation = _animation === void 0 ? "accelerateDecelerateFastest" : _animation, setIsOpen = param.setIsOpen, _overlayColor = param.overlayColor, overlayColor = _overlayColor === void 0 ? "dark" : _overlayColor, analyticsName = param.analyticsName, trackImpression = param.trackImpression, _dismissable = param.dismissable, dismissable = _dismissable === void 0 ? !0 : _dismissable, _showCloseButton = param.showCloseButton, showCloseButton = _showCloseButton === void 0 ? !0 : _showCloseButton, children = param.children;
    var overlayProps = overlayColor === "dark" ? {
        backgroundColor: Dialog_dialogTokens.color.scrim
    } : overlayColor === "transparent" ? {
        backgroundColor: void 0
    } : {
        backgroundColor: Dialog_dialogTokens.color.scrimInverse,
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(BackgroundBlur, {
            blurRadius: Dialog_dialogTokens.backgroundBlur.default,
            style: {
                position: "absolute",
                top: 0,
                bottom: 0,
                right: 0,
                left: 0
            }
        })
    }, maxHeightTokenValue = (0,tokens/* getPercentageTokenValue */.Re)(Dialog_dialogTokens.percentage.maxHeight), minHeightTokenValue = (0,tokens/* getPercentageTokenValue */.Re)(Dialog_dialogTokens.percentage.minHeightWidth), dimensions = (0,useWindowDimensions/* default */.Z)(), maxSheetHeight = (0,react.useMemo)(function() {
        var percent = parseInt(maxHeightTokenValue, 10);
        return cjs.isWeb ? "".concat(percent, "dvh") : 0.01 * percent * dimensions.height;
    }, [
        dimensions.height,
        maxHeightTokenValue
    ]), minSheetHeight = (0,react.useMemo)(function() {
        var percent = parseInt(minHeightTokenValue, 10);
        return cjs.isWeb ? "".concat(percent, "dvh") : 0.01 * percent * dimensions.height;
    }, [
        dimensions.height,
        minHeightTokenValue
    ]);
    return /* @__PURE__ */ (0,jsx_runtime.jsxs)(Dialog/* Dialog */.Vq, {
        modal: !0,
        open: isOpen,
        onOpenChange: dismissable ? setIsOpen : void 0,
        children: [
            /* @__PURE__ */ (0,jsx_runtime.jsxs)(Dialog/* Dialog.Portal */.Vq.Portal, {
                children: [
                    /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Overlay */.Vq.Overlay, (0,_object_spread/* default */.Z)({
                        animation: animation,
                        animateOnly: [
                            "opacity"
                        ],
                        enterStyle: {
                            opacity: 0
                        },
                        exitStyle: {
                            opacity: 0
                        }
                    }, overlayProps), "overlay"),
                    /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Content */.Vq.Content, {
                        animation: animation,
                        animateOnly: [
                            "opacity",
                            "transform"
                        ],
                        enterStyle: {
                            opacity: 0,
                            y: 20
                        },
                        exitStyle: {
                            opacity: 0,
                            y: 20
                        },
                        overflow: "hidden",
                        padding: 0,
                        borderWidth: 0,
                        backgroundColor: Dialog_dialogTokens.color.background.default,
                        borderRadius: Dialog_dialogTokens.cornerRadius.desktop.default,
                        minWidth: (0,tokens/* getPercentageTokenValue */.Re)(Dialog_dialogTokens.percentage.minHeightWidth),
                        minHeight: minHeightTokenValue,
                        maxHeight: maxHeightTokenValue,
                        $largerThanSM: {
                            maxWidth: (0,tokens/* getPercentageTokenValue */.Re)(Dialog_dialogTokens.percentage.maxWidth)
                        },
                        children: /* @__PURE__ */ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                            analyticsName: analyticsName,
                            trackImpression: trackImpression,
                            flexGrow: 1,
                            flexShrink: 1,
                            position: "relative",
                            children: [
                                dismissable && showCloseButton && /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Close */.Vq.Close, {
                                    asChild: !0,
                                    children: /* @__PURE__ */ (0,jsx_runtime.jsx)(IconButton/* CloseButton */.PZ, {
                                        size: "large",
                                        analyticsName: "".concat(analyticsName, "-close"),
                                        position: "absolute",
                                        zIndex: 1,
                                        top: 0,
                                        right: 0,
                                        margin: Dialog_dialogTokens.padding.actions.closeIconButton.desktop
                                    })
                                }),
                                children
                            ]
                        })
                    }, "content")
                ]
            }),
            /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Adapt */.Vq.Adapt, {
                when: "smallerThanMD",
                children: /* @__PURE__ */ (0,jsx_runtime.jsxs)(Dialog/* Dialog.Sheet */.Vq.Sheet, {
                    modal: !0,
                    dismissOnSnapToBottom: dismissable,
                    moveOnKeyboardChange: !0,
                    dismissOnOverlayPress: dismissable,
                    disableDrag: !dismissable,
                    animation: animation,
                    snapPointsMode: "fit",
                    children: [
                        /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Sheet.Overlay */.Vq.Sheet.Overlay, (0,_object_spread/* default */.Z)({
                            animation: animation,
                            animateOnly: [
                                "opacity"
                            ],
                            enterStyle: {
                                opacity: 0
                            },
                            exitStyle: {
                                opacity: 0
                            }
                        }, overlayProps), "overlay"),
                        dismissable && /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Sheet.Handle */.Vq.Sheet.Handle, {
                            borderRadius: Dialog_dialogTokens.cornerRadius.mobile.handle,
                            height: Dialog_dialogTokens.mobile.handle.height,
                            width: Dialog_dialogTokens.mobile.handle.width,
                            alignSelf: "center",
                            marginLeft: 0,
                            marginRight: 0,
                            marginBottom: Dialog_dialogTokens.margin.mobile.handle.bottom,
                            backgroundColor: overlayColor === "dark" ? Dialog_dialogTokens.color.background.mobile.handle : Dialog_dialogTokens.color.background.mobile.handleInverse,
                            opacity: (0,tokens/* getOpacityTokenValue */.vs)(Dialog_dialogTokens.opacity.mobileHandle)
                        }),
                        /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Sheet.Frame */.Vq.Sheet.Frame, {
                            backgroundColor: Dialog_dialogTokens.color.background.default,
                            borderTopLeftRadius: Dialog_dialogTokens.cornerRadius.mobile.default,
                            borderTopRightRadius: Dialog_dialogTokens.cornerRadius.mobile.default,
                            maxHeight: maxSheetHeight,
                            minHeight: minSheetHeight,
                            children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Adapt.Contents */.Vq.Adapt.Contents, {})
                        })
                    ]
                })
            })
        ]
    });
};


;// CONCATENATED MODULE: ../bricks-next/dist/jsx/components/Dialog/index.js




var components_Dialog_Dialog = (0,cjs.withStaticProperties)(Dialog_Dialog, {
    Content: Content,
    Actions: Actions
});



/***/ }),

/***/ 11509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ SimpleCheckbox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59106);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64069);
/* harmony import */ var _tamagui_checkbox_headless__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6805);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64978);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _generated_icons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(78578);
/* harmony import */ var _helpers_useObservabilitySafe__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21713);
/* harmony import */ var _helpers_utils__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(71868);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(44142);
/* harmony import */ var _shared_TrackableContainer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11706);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(34816);
/* harmony import */ var _shared_hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43137);
/* harmony import */ var _shared_hooks__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18089);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31549);
















var checkboxTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__/* .tokens.radioCheckbox */ .T.radioCheckbox, SimpleCheckbox = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(_param, ref) {
    var analyticsName = _param.analyticsName, label = _param.label, value = _param.value, _defaultChecked = _param.defaultChecked, defaultChecked = _defaultChecked === void 0 ? !1 : _defaultChecked, disabled = _param.disabled, invalid = _param.invalid, id = _param.id, onPress = _param.onPress, name = _param.name, trackImpression = _param.trackImpression, checked = _param.checked, ariaLabel = _param.ariaLabel, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "analyticsName",
        "label",
        "value",
        "defaultChecked",
        "disabled",
        "invalid",
        "id",
        "onPress",
        "name",
        "trackImpression",
        "checked",
        "ariaLabel"
    ]);
    var _$ref = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.useProps)(props), _size = _$ref.size, size = _size === void 0 ? "medium" : _size, trackJourneyEvent = (0,_helpers_useObservabilitySafe__WEBPACK_IMPORTED_MODULE_5__/* .useObservabilitySafe */ .r)().trackJourneyEvent, _$ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultChecked), internalChecked = _$ref1[0], setInternalChecked = _$ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        checked !== void 0 && setInternalChecked(checked);
    }, [
        checked
    ]);
    var onCheckedChange = function(e) {
        e.stopPropagation(), onPress && onPress(value, !internalChecked), trackJourneyEvent("platform", "checkboxClickEvent", {
            targetName: analyticsName,
            optionName: value
        });
    }, _$ref2 = (0,_tamagui_checkbox_headless__WEBPACK_IMPORTED_MODULE_6__/* .useCheckbox */ .O)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        name: name,
        value: value,
        defaultChecked: defaultChecked,
        disabled: disabled,
        onPress: onCheckedChange
    }, props), [
        internalChecked,
        setInternalChecked
    ], ref), checkboxProps = _$ref2.checkboxProps, checkboxRef = _$ref2.checkboxRef, bubbleInput = _$ref2.bubbleInput, inputId = (0,_shared_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useInputId */ .U0)(id), _$ref3 = (0,_shared_hooks__WEBPACK_IMPORTED_MODULE_9__/* .useCheckBoxRadioState */ .D)({
        checked: internalChecked,
        disabled: disabled,
        invalid: invalid
    }), rowState = _$ref3.rowState, buttonState = _$ref3.buttonState, handleFocus = _$ref3.handleFocus, handleBlur = _$ref3.handleBlur, _$ref4 = getCheckMarkIconStyle(size, buttonState), checkMarkSize = _$ref4.checkMarkSize, checkMarkColor = _$ref4.checkMarkColor;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_shared_TrackableContainer__WEBPACK_IMPORTED_MODULE_10__/* .TrackableContainer */ .z, {
        analyticsName: analyticsName,
        trackImpression: trackImpression,
        eventName: "checkboxViewEvent",
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(CheckboxRowButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, checkboxProps), {
            "aria-invalid": _tamagui_core__WEBPACK_IMPORTED_MODULE_4__.isWeb ? invalid : void 0,
            "aria-required": _tamagui_core__WEBPACK_IMPORTED_MODULE_4__.isWeb ? props.required : void 0,
            "aria-label": ariaLabel,
            ref: checkboxRef,
            size: size,
            state: rowState,
            onFocus: handleFocus,
            onBlur: handleBlur,
            focusable: !disabled,
            id: inputId,
            children: [
                /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(Checkbox, {
                    disabled: disabled,
                    size: size,
                    state: {
                        state: buttonState,
                        checked: internalChecked
                    },
                    onFocus: handleFocus,
                    onBlur: handleBlur,
                    focusable: !1,
                    alignSelf: "flex-start",
                    children: [
                        internalChecked === !0 && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_generated_icons__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            size: checkMarkSize,
                            color: checkMarkColor
                        }),
                        bubbleInput
                    ]
                }),
                label && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Box__WEBPACK_IMPORTED_MODULE_13__/* .Box */ .x, {
                    alignSelf: "center",
                    flex: 1,
                    children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
                        alignSelf: "flex-start",
                        textAlign: "left",
                        tag: "label",
                        htmlFor: id,
                        cursor: "inherit",
                        typography: checkboxTokens.typography.simpleCheckbox[size],
                        color: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_15__/* .isKeyOfObject */ .E)(buttonState, checkboxTokens.color.content.valueText.state) ? checkboxTokens.color.content.valueText.state[buttonState] : checkboxTokens.color.content.valueText.default,
                        children: label
                    })
                })
            ]
        }))
    });
}), CheckboxRowButton = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.View, {
    tag: "button",
    display: "flex",
    flexDirection: "row",
    /**
   * Combined size and state into one variant because there are multiple times we need to use both to determine the style (especially for small/xsmall)
   * Seperating these two variants causes confusion and causes strange overrides
   */ variants: {
        state: function(state) {
            return {
                cursor: state === "inactive" ? "default" : "pointer"
            };
        },
        size: function(size) {
            var updatedSize = size === "xsmall" ? "small" : size;
            return {
                borderColor: "$transparent",
                backgroundColor: "$transparent",
                paddingTop: checkboxTokens.margin.simpleCheckbox.topBottom[updatedSize],
                paddingBottom: checkboxTokens.margin.simpleCheckbox.topBottom[updatedSize],
                gap: checkboxTokens.padding.simpleCheckbox[updatedSize]
            };
        }
    }
}), Checkbox = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.Stack, {
    borderWidth: checkboxTokens.borderWidth.default,
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "auto",
    alignSelf: "center",
    variants: {
        size: function(size) {
            var widthAndHeight = {
                xsmall: checkboxTokens.size.element.radio.exterior.xsmall,
                small: checkboxTokens.size.element.radio.exterior.small,
                medium: checkboxTokens.size.element.radio.exterior.medium
            };
            return {
                borderRadius: checkboxTokens.cornerRadius.element.checkbox[size === "small" || size === "xsmall" ? "smallXsmall" : size],
                width: widthAndHeight[size],
                height: widthAndHeight[size]
            };
        },
        // eslint-disable-next-line jsdoc/require-jsdoc
        state: function(param) {
            var state = param.state, checked = param.checked;
            return {
                borderColor: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_15__/* .isKeyOfObject */ .E)(state, checkboxTokens.color.border.element.checkbox.state) ? checkboxTokens.color.border.element.checkbox.state[state] : checkboxTokens.color.border.element.checkbox.default,
                backgroundColor: (checked || state === "inactive") && (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_15__/* .isKeyOfObject */ .E)(state, checkboxTokens.color.background.element.checkboxRadio.state) ? checkboxTokens.color.background.element.checkboxRadio.state[state] : "$transparent"
            };
        }
    }
}), getCheckMarkIconStyle = function(size, state) {
    return {
        checkMarkSize: size === "small" ? 20 : 24,
        checkMarkColor: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_15__/* .isKeyOfObject */ .E)(state, checkboxTokens.color.content.element.checkIcon.state) ? checkboxTokens.color.content.element.checkIcon.state[state] : checkboxTokens.color.content.element.checkIcon.default
    };
};



/***/ }),

/***/ 18089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ useCheckBoxRadioState; },
/* harmony export */   "q": function() { return /* binding */ getCustomRadioCheckboxRowStyling; }
/* harmony export */ });
/* harmony import */ var _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64069);
/* harmony import */ var _helpers_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71868);
/* harmony import */ var _shared_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43137);



var radioCheckbox = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__/* .tokens.radioCheckbox */ .T.radioCheckbox, useCheckBoxRadioState = function(param) {
    var disabled = param.disabled, errorText = param.errorText, invalid = param.invalid, onFocus = param.onFocus, onBlur = param.onBlur, checked = param.checked;
    var ref = (0,_shared_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useInputState */ .U1)({
        disabled: disabled,
        errorText: errorText,
        invalid: invalid,
        onFocus: onFocus,
        onBlur: onBlur
    }), state = ref.state, handleFocus = ref.handleFocus, handleBlur = ref.handleBlur, setFocused = ref.setFocused, rowState = state || (checked && checked !== "indeterminate" ? "selected" : void 0);
    return {
        rowState: rowState,
        buttonState: state === "focused" && checked ? "selected" : rowState,
        handleFocus: handleFocus,
        handleBlur: handleBlur,
        setFocused: setFocused
    };
}, getCustomRadioCheckboxRowStyling = function(param) {
    var size = param.size, state = param.state;
    var isXSmall = size === "xsmall", disabled = state === "inactive", focused = state === "focused", hoverStyle = disabled ? {} : {
        borderColor: isXSmall ? "$transparent" : radioCheckbox.color.border.row.state.hover,
        backgroundColor: isXSmall ? radioCheckbox.color.background.element.row.state.hover : "$transparent"
    }, focusStyle = focused && !disabled ? {
        borderColor: radioCheckbox.color.border.row.state.focused,
        borderWidth: radioCheckbox.borderWidth.default
    } : {}, cursor = state === "inactive" ? "default" : "pointer", borderColor = isXSmall ? void 0 : (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .isKeyOfObject */ .E)(state, radioCheckbox.color.border.row.state) ? radioCheckbox.color.border.row.state[state] : radioCheckbox.color.border.row.default;
    return {
        backgroundColor: "$transparent",
        height: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .isKeyOfObject */ .E)(size, radioCheckbox.size.rowHeight) ? radioCheckbox.size.rowHeight[size] : 0,
        paddingRight: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .isKeyOfObject */ .E)(size, radioCheckbox.padding.leftRight) ? radioCheckbox.padding.leftRight[size] : 0,
        paddingLeft: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .isKeyOfObject */ .E)(size, radioCheckbox.padding.leftRight) ? radioCheckbox.padding.leftRight[size] : 0,
        borderRadius: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .isKeyOfObject */ .E)(size, radioCheckbox.cornerRadius.row) ? radioCheckbox.cornerRadius.row[size] : 0,
        borderWidth: radioCheckbox.borderWidth.default,
        // hides the border if it's xsmall
        borderColor: borderColor || "$transparent",
        hoverStyle: hoverStyle,
        focusStyle: focusStyle,
        cursor: cursor
    };
};



/***/ }),

/***/ 43137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gd": function() { return /* binding */ useInputName; },
/* harmony export */   "N7": function() { return /* binding */ useFrameFocus; },
/* harmony export */   "U0": function() { return /* binding */ useInputId; },
/* harmony export */   "U1": function() { return /* binding */ useInputState; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88149);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64978);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_1__);



var useInputId = function(id) {
    var backupId = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)();
    return id || backupId;
}, useInputName = function(name) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var ref1;
        _tamagui_core__WEBPACK_IMPORTED_MODULE_1__.isWeb && name && (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ref.current, HTMLElement) && ((ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.setAttribute("name", name));
    }, [
        name
    ]), ref;
}, useFrameFocus = function(ref) {
    var focusRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    return {
        inputRef: (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_1__.useComposedRefs)(ref, focusRef),
        handleFramePress: function() {
            var _$ref;
            (_$ref = focusRef.current) === null || _$ref === void 0 ? void 0 : _$ref.focus();
        }
    };
}, useInputState = function(param) {
    var disabled = param.disabled, errorText = param.errorText, invalid = param.invalid, onFocus = param.onFocus, onBlur = param.onBlur;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), focused = ref[0], setFocused = ref[1], handleFocus = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        setFocused(!0), onFocus && onFocus(e);
    }, [
        onFocus
    ]), handleBlur = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        setFocused(!1), onBlur && onBlur(e);
    }, [
        onBlur
    ]);
    return {
        state: disabled ? "inactive" : errorText || invalid ? "error" : focused ? "focused" : void 0,
        handleFocus: handleFocus,
        handleBlur: handleBlur,
        setFocused: setFocused
    };
};



/***/ }),

/***/ 11706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ TrackableContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59106);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _helpers_analytics__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63522);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44142);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31549);






var TrackableContainer = function(_param) {
    var analyticsName = _param.analyticsName, trackImpression = _param.trackImpression, eventName = _param.eventName, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "analyticsName",
        "trackImpression",
        "eventName"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null), Component = /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Box__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .x, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: ref
    }, props));
    return analyticsName && trackImpression ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_helpers_analytics__WEBPACK_IMPORTED_MODULE_5__/* .ComponentWithViewTracking */ .o, {
        Component: Component,
        analyticsName: analyticsName,
        eventName: eventName,
        ref: ref
    }) : Component;
};



/***/ }),

/***/ 71868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ isKeyOfObject; }
/* harmony export */ });
function isKeyOfObject(key, obj) {
    return !!key && key in obj;
}



/***/ }),

/***/ 60757:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 47216:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconExclamationCircle; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72035);
/**
 * @license @tabler/icons-react v3.44.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 9v4", "key": "svg-1" }], ["path", { "d": "M12 16v.01", "key": "svg-2" }]];
const IconExclamationCircle = (0,_createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("outline", "exclamation-circle", "ExclamationCircle", __iconNode);


//# sourceMappingURL=IconExclamationCircle.mjs.map


/***/ }),

/***/ 2418:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconMail; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72035);
/**
 * @license @tabler/icons-react v3.44.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { "d": "M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10", "key": "svg-0" }], ["path", { "d": "M3 7l9 6l9 -6", "key": "svg-1" }]];
const IconMail = (0,_createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("outline", "mail", "Mail", __iconNode);


//# sourceMappingURL=IconMail.mjs.map


/***/ }),

/***/ 45642:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconMessage; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72035);
/**
 * @license @tabler/icons-react v3.44.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12", "key": "svg-2" }]];
const IconMessage = (0,_createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("outline", "message", "Message", __iconNode);


//# sourceMappingURL=IconMessage.mjs.map


/***/ }),

/***/ 5899:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconShieldLockFilled; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72035);
/**
 * @license @tabler/icons-react v3.44.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { "d": "M11.998 2l.118 .007l.059 .008l.061 .013l.111 .034a.993 .993 0 0 1 .217 .112l.104 .082l.255 .218a11 11 0 0 0 7.189 2.537l.342 -.01a1 1 0 0 1 1.005 .717a13 13 0 0 1 -9.208 16.25a1 1 0 0 1 -.502 0a13 13 0 0 1 -9.209 -16.25a1 1 0 0 1 1.005 -.717a11 11 0 0 0 7.531 -2.527l.263 -.225l.096 -.075a.993 .993 0 0 1 .217 -.112l.112 -.034a.97 .97 0 0 1 .119 -.021l.115 -.007zm.002 7a2 2 0 0 0 -1.995 1.85l-.005 .15l.005 .15a2 2 0 0 0 .995 1.581v1.769l.007 .117a1 1 0 0 0 1.993 -.117l.001 -1.768a2 2 0 0 0 -1.001 -3.732z", "key": "svg-0" }]];
const IconShieldLockFilled = (0,_createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("filled", "shield-lock-filled", "ShieldLockFilled", __iconNode);


//# sourceMappingURL=IconShieldLockFilled.mjs.map


/***/ }),

/***/ 74313:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconTruckFilled; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72035);
/**
 * @license @tabler/icons-react v3.44.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { "d": "M13 4a1 1 0 0 1 1 1h4a1 1 0 0 1 .783 .378l.074 .108l3 5l.055 .103l.04 .107l.029 .109l.016 .11l.003 .085v6a1 1 0 0 1 -1 1h-1.171a3.001 3.001 0 0 1 -5.658 0h-4.342a3.001 3.001 0 0 1 -5.658 0h-1.171a1 1 0 0 1 -1 -1v-11a2 2 0 0 1 2 -2zm-6 12a1 1 0 1 0 0 2a1 1 0 0 0 0 -2m10 0a1 1 0 1 0 0 2a1 1 0 0 0 0 -2m.434 -9h-3.434v3h5.234z", "key": "svg-0" }]];
const IconTruckFilled = (0,_createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("filled", "truck-filled", "TruckFilled", __iconNode);


//# sourceMappingURL=IconTruckFilled.mjs.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3985,109,9115,5959,820,9927,8815,1218,1543,6184,8948,8797,2040,8906,9877,878,6850,8216,2763,3734,9774,2888,179], function() { return __webpack_exec__(20582); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);